import { Notyf } from "notyf";
var notyf = null;

class ServiceNotyfManager {
    constructor() {
        notyf = new Notyf({
            types: [
                {
                    type: 'success',
                    background: '#3dc763',
                    duration: 2000,
                    dismissible: true
                },
                {
                    type: 'warning',
                    background: 'orange',
                    duration: 2000,
                    dismissible: true
                },
                {
                    type: 'error',
                    background: 'indianred',
                    duration: 2000,
                    dismissible: true
                }
            ],
        });
    }

    success(message) {
        this.openNotyf(message, "success");
    }

    warning(message) {
        this.openNotyf(message, "warning");
    }

    error(message) {
        this.openNotyf(message, "error");
    }

    openNotyf(message, type) {
        notyf.open({
            type,
            message,
        });
    }

    dismissAll() {
        return notyf.dismissAll();
    }
}

let notyfInstance = null;

export function InitNotyf() {
    notyfInstance = new ServiceNotyfManager();
    return notyfInstance;
}

export default function GetNotyfInstance() {
    if (!notyfInstance) {
        InitNotyf();
    }
    return notyfInstance;
}